import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { TStringField } from '../../../../types/sitecore.types';
import { appendRootToRichTextInternalLinks } from '../../../../utils/appendRootToRichTextInternalLinks.utils';

export type TAccordionItemColumnData = {
  shortDescription: string;
};

export type TAccordionItemData = {
  id: TStringField;
  columns?: Array<TAccordionItemColumnData>;
};

export type TAccordionItems = {
  columnData: TAccordionItemData;
};

const AccordionColumns: FC<TAccordionItems> = (props) => {
  const {
    columnData: { columns },
  } = props;
  const cardItemLength = columns?.length === 1;

  return (
    <div className="accordion-item__card-description">
      {columns?.map((item, index) => {
        const listItemslength = (item?.shortDescription?.match(/<li>/g) || []).length;

        return (
          <RichText
            tag="div"
            key={index}
            field={{ value: appendRootToRichTextInternalLinks(item.shortDescription) }}
            className={`accordion-item__card-rich-text ${listItemslength > 15 ? 'accordion-item__card-rich-text--column' : ''}   ${
              cardItemLength ? 'singleCol' : 'multipleCol'
            } rich-text`}
            editable={false}
          />
        );
      })}
    </div>
  );
};

export default React.memo(AccordionColumns);
